import request from "@/utils/request";
// import { decorType, clientType } from "@/utils/decor-types";
// import { api } from "~/ui-domain";

const cur = "/admin-api/system/";
/**
 * 添加页面
 *
 */
export function addPageJson(data, token, businessType) {
  return request({
    url: `${cur}mini-app-page/create`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      "Business-Type": businessType,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    data,
  });
}

/**
 * 更新页面数据
 * @param id
 * @param data
 * @returns {AxiosPromise<any>|Promise<unknown>|*}
 */
export function updatePageJson(data, token, businessType) {
  // 客户端类型
  return request({
    url: `${cur}mini-app-page/update`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      "Business-Type": businessType,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    data,
  });
}

/**
 * 获取页面详情
 * @param id
 * @param loading
 * @returns {AxiosPromise<any>|Promise<unknown>|*}
 */
export function getPageDetailJson(id, token) {
  return request({
    url: `${cur}mini-app-page/get?id=${id}`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
}

export function getPageJson(token, businessType) {
  return request({
    url: `${cur}mini-app-page/page?pageSize=-1`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "Business-Type": businessType,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
}
export function getLinkPageJson(token, businessType) {
  return request({
    url: `${cur}mini-app-link/page?pageSize=-1`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      "Business-Type": businessType,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
}
